//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return {
      visible:false,
      content:"",
    }
  },
  watch:{
    visible:{
      handler(val){
        val && (this.content='')
      }
    }
  },
  methods:{
    /**
     * @Author: likk
     * @description: 确定
     * @param {*}
     * @return {*}
     */      
    handleSubmit(){
      this.$emit('submit',this.content)
    },
    /**
     * @Author: likk
     * @description: 弹框显示/隐藏状态切换
     * @param {*}
     * @return {*}
     */   
    handleVisible(status){
      this.visible = status;
    }   
  }
}
